var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-gallery"},_vm._l((_vm.imgs),function(img,index){return _c('div',{key:index,staticClass:"grid-item"},[_c('figure',[_c('img',{attrs:{"src":img.foto,"alt":""}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }